import { Money } from '@ap/interface-bspc-core';
import { RequiredAssetDetail } from '@ap/ap-interface-apix-hypotheken-berekening';

export class RequiredAssetDetailBuilder {
    private residualDebt: Money;
    private deficiencyMortgage: Money;
    private closingCost: Money;
    private sellingCost: Money;
    private ownInvestmentRenovationAmount: Money;
    private ownInvestmentSustainabilityAmount: Money;

    withResidualDebt(residualDebt: Money): this {
        this.residualDebt = residualDebt;
        return this;
    }

    withDeficiencyMortgage(deficiencyMortgage: Money): this {
        this.deficiencyMortgage = deficiencyMortgage;
        return this;
    }

    withClosingCost(closingCost: Money): this {
        this.closingCost = closingCost;
        return this;
    }

    withSellingCost(sellingCost: Money): this {
        this.sellingCost = sellingCost;
        return this;
    }

    withOwnInvestmentRenovationAmount(ownInvestmentRenovationAmount: Money): this {
        this.ownInvestmentRenovationAmount = ownInvestmentRenovationAmount;
        return this;
    }

    withOwnInvestmentSustainabilityAmount(ownInvestmentSustainabilityAmount: Money): this {
        this.ownInvestmentSustainabilityAmount = ownInvestmentSustainabilityAmount;
        return this;
    }

    build(): RequiredAssetDetail {
        return {
            residual_debt: this.residualDebt,
            deficiency_mortgage: this.deficiencyMortgage,
            closing_cost: this.closingCost,
            selling_cost: this.sellingCost,
            own_investment_renovation_amount: this.ownInvestmentRenovationAmount,
            own_investment_sustainability_amount: this.ownInvestmentSustainabilityAmount
        } as RequiredAssetDetail;
    }
}

export const aRequiredAssetDetail = new RequiredAssetDetailBuilder();
